import { IComponentOptions } from 'angular';
import { StudentPanelCtrl } from './student-panel-ng1.controller';

export const StudentPanelComponent: IComponentOptions = {
  template: require('./student-panel-ng1.html'),
  bindings: {
    panelHeader: '@',
    summaryItems: '<',
    panelId: '@',
  },
  transclude: true,
  controller: StudentPanelCtrl,
};

angular.module('nv.singleStudent').component('studentPanelNg1', StudentPanelComponent);
